import { Button, Card } from "@peer-start/ui";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

export function PassportQueryState({
  error,
  loading,
  onRetry,
  children,
}: {
  error: boolean;
  loading: boolean;
  onRetry: () => void;
  children: ReactNode;
}) {
  const { t } = useTranslation();
  if (loading) return <p className="font-medium">{t("common.loading")}</p>;
  if (error)
    return (
      <Card className="text-center">
        <p className="font-medium">{t("common.error")}</p>
        <Button className="mt-4" controlId="passport.retry" onClick={onRetry}>
          {t("common.retry")}
        </Button>
      </Card>
    );
  return children;
}
